import token, { tokenToVars } from '../token';
import List from './list';

export { List };
export default tokenToVars(List, token);
